module.exports = __webpack_public_path__ + "static/media/Samus.5a5fe838.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Samus.png
// module id = 50
// module chunks = 0